module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zk-tree",
    class: {
      'zk-tree--highlight-current': _vm.highlightCurrent
    }
  }, _vm._l((_vm.tree.root.childNodes), function(child) {
    return _c('zk-tree-node', {
      attrs: {
        "node": child,
        "props": _vm.props,
        "expandedAll": _vm.expandedAll,
        "render-content": _vm.renderContent
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-f3e3ee02"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/packages/tree/src/tree.vue
// module id = 290
// module chunks = 0